const defaultFeatureMap = {
    featureIndicator: null,
    featureTitle: null,
    objectIndicatorPos: null
};

const featureMap = ( state = defaultFeatureMap, action ) => {
    switch(action.type){
        case "SET_FEATURE_INDICATOR":
            return {
                ...state,
                featureIndicator: action.indicatorRef,
                featureTitle: action.title
            };
        case "SET_OBJECT_INDICATOR_POSITION":
            return {
                ...state,
                objectIndicatorPos: action.objectPos
            };
        case "REMOVE_OBJECT_INDICATOR_POSITION":
            return {
                ...state,
                objectIndicatorPos: null
            };
        case "SET_BOTH_MAP_POSITIONS":
            return {
                featureIndicator: action.indicatorRef,
                objectIndicatorPos: action.objectPos
            };
        case "RESET_MAP_POSITION":
            return defaultFeatureMap;
        default:
            return state;
    }
};

export default featureMap;



// WEBPACK FOOTER //
// ./src/reducers/feature-map.js